
import { useState } from "react"
import { useSelector } from "react-redux";
import Modal from "../../Utils/Modal.module.css"
import { BASE_URL, UPDATE_PASSWORD } from "../../Utils/constant"
import { Icon } from 'react-icons-kit'
import { basic_eye } from 'react-icons-kit/linea/basic_eye';
import { basic_eye_closed } from 'react-icons-kit/linea/basic_eye_closed';
import cogoToast from "cogo-toast-react-17-fix";
import Loader from "../Loader";
import API from "../../ApiConfig"
import { BUTTONS } from "../../Utils/Strings";
import { PASSWORD_CHECK } from "../../Utils/helper";
const ChangePass = ({ setPopup }) => {
  const [FormValues, setFormValues] = useState({
    oldPassword: '',
    newPassword: '',
    confirmPassword: ''
  });
  const [err, setErr] = useState({});
  const [loading, setLoading] = useState(false)
  const [passVisible, setPassVisible] = useState({ oldField: false, newField: false, confirmField: false })
  const User = useSelector(state => state.User)

  const Reset = (e) => {
    e.preventDefault();
    setFormValues({
      oldPassword: '',
      newPassword: '',
      confirmPassword: ''
    })
  }


  const handleVisibility = (field) => {
    setPassVisible((prevState) => ({
      ...prevState,
      [field]: !prevState[field]
    }))
  }
  const Submit = (e) => {
    e.preventDefault();
    if (Validate()) {
      let formData = {
        old_password: FormValues.oldPassword,
        new_password: FormValues.newPassword,
        confirm_password: FormValues.confirmPassword
      }
      setLoading(true)
      setPopup(true)
      API.put(UPDATE_PASSWORD + User.user_id, { ...formData })
        .then(res => {
          setPopup(false)
          setLoading(false)
          let data = res.data;
          if (data.success == true) {
            cogoToast.success(data.message);
          }
          else {
            cogoToast.error(data.message);
          }
        })
        .catch(err => {
          setPopup(false)
          setLoading(false)
          cogoToast.error(err.response.data.detail)
        })
    }
  }
  const Validate = () => {
    let isValid = true;
    const newErr = {};
    if (!FormValues.oldPassword) {
      isValid = false;
      newErr.oldPassword = "Enter old password!!";
    }
    if (!FormValues.newPassword) {
      isValid = false;
      newErr.newPassword = "Enter new password to change!!";
    }
    else if (!PASSWORD_CHECK(FormValues.newPassword)) {
      isValid = false;
      newErr.newPassword = "Your password should be between 8 to 13 characters which contain at least one lowercase letter, one uppercase letter, one numeric digit, and one special character!!"
    }
    if (!FormValues.confirmPassword) {
      isValid = false;
      newErr.confirmPassword = "Re-type new password to confirm!!"
    }
    else if (FormValues.newPassword !== FormValues.confirmPassword) {
      isValid = false;
      newErr.confirmPassword = "Confirm and new password do not match!!"
    }
    // console.log(newErr, isValid);
    setErr(newErr);
    return isValid;
  }
  return (
    <>
      <Loader isOpen={loading} />
      <form>
        <div className={Modal.modalBody}>
          Existing Password
          <div style={{ width: "100%" }}>
            <div className={Modal.PassInput}>
              <input type={passVisible.oldField ? "text" : "password"} className={Modal.input} placeholder="Old Password" value={FormValues.oldPassword} onChange={(e) => setFormValues({ ...FormValues, oldPassword: e.target.value })} />
              {FormValues.oldPassword &&
                <span onClick={() => handleVisibility('oldField')}><Icon icon={passVisible.oldField ? basic_eye : basic_eye_closed} size={20} /></span>}
            </div>
            {err.oldPassword && <span style={{ color: "red", fontWeight: "500" }}>{err.oldPassword}</span>}
          </div>
          New Password
          <div style={{ width: '100%' }}>
            <div className={Modal.PassInput}>
              <input type={passVisible.newField ? "text" : "password"} className={Modal.input} placeholder="New Password" value={FormValues.newPassword} onChange={(e) => setFormValues({ ...FormValues, newPassword: e.target.value })} />
              {FormValues.newPassword &&
                <span onClick={() => handleVisibility('newField')}><Icon icon={passVisible.newField ? basic_eye : basic_eye_closed} size={20} /></span>}
            </div>
            {err.newPassword && <span style={{ color: "red", fontWeight: "500" }}>{err.newPassword}</span>}
          </div>
          Confirm Password
          <div style={{ width: "100%" }}>
            <div className={Modal.PassInput}>
              <input type={passVisible.confirmField ? "text" : "password"} className={Modal.input} placeholder="Confirm Password" value={FormValues.confirmPassword} onChange={(e) => setFormValues({ ...FormValues, confirmPassword: e.target.value })} />
              {FormValues.confirmPassword &&
                <span onClick={() => handleVisibility('confirmField')}><Icon icon={passVisible.confirmField ? basic_eye : basic_eye_closed} size={20} /></span>}
            </div>
            {err.confirmPassword && <span style={{ color: "red", fontWeight: "500" }}>{err.confirmPassword}</span>}
          </div>
        </div>
        <hr />
        <div className={Modal.buttonBed}>
          <button onClick={e => Reset(e)} className="btn btn-secondary ">{BUTTONS.RESET}</button>
          <button onClick={(e) => Submit(e)} className="btn btn-primary" style={{ width: "22%" }}>{loading ? BUTTONS.SAVING : BUTTONS.SAVE}</button>
        </div>
      </form>
    </>
  )
}

export default ChangePass